import React from "react";
import PropTypes from "prop-types";
import { cn } from "../cn";
import styles from "./Progress.module.scss";

/** Progress — thin bar. `value`/`max` (defaults 0..100). */
export function Progress({ value = 0, max = 100, className, ...rest }) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div
      className={cn(styles.track, className)}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      {...rest}
    >
      <div className={styles.fill} style={{ width: `${pct}%` }} />
    </div>
  );
}

Progress.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
  className: PropTypes.string,
};

export default Progress;
